import { Language } from "../i18n/settings";
import { SearchLocation } from "../utils/googleMapsUtils";

export type GetRoomCategoryPriceResponse = {
    total: number;
    serviceFee: number;
    cleaningFee: number;
    additionalGuestFee: number;
    taxPercentage: number;
    instalmentNumber: number;
    period: Period;
    priceMultiplier: number;
    accommodationPrice: number;
    discount: number;
};

export type Period = {
    startDate: string;
    endDate: string;
};

export type GetRoomCategoryPriceRequest = {
    roomCategoryId: string;
    checkinDate: Date;
    checkoutDate: Date;
    numberOfAdults: number;
};

export type GetRoomCalendarRequest = {
    roomCategoryId: string;
    startDate: Date; // in format yyyy-MM-dd
    endDate: Date; // same format
};

// ["2023-01-01;B;MIN:1;MAX:999","2023-01-02;B;MIN:1;MAX:999","2023-01-03;B;MIN:1;MAX:999","2023-01-04;B;MIN:1;MAX:999","2023-01-05;B;MIN:1;MAX:999","2023-01-06;B;MIN:1;MAX:999","2023-01-07;B;MIN:1;MAX:999","2023-01-08;B;MIN:1;MAX:999","2023-01-09;B;MIN:1;MAX:999","2023-01-10;B;MIN:1;MAX:999","2023-01-11;B;MIN:1;MAX:999","2023-01-12;B;MIN:1;MAX:999","2023-01-13;B;MIN:1;MAX:999","2023-01-14;B;MIN:1;MAX:999","2023-01-15;B;MIN:1;MAX:999","2023-01-16;B;MIN:1;MAX:999","2023-01-17;B;MIN:1;MAX:999","2023-01-18;B;MIN:1;MAX:999","2023-01-19;B;MIN:1;MAX:999","2023-01-20;B;MIN:1;MAX:999","2023-01-21;B;MIN:1;MAX:999","2023-01-22;B;MIN:1;MAX:999","2023-01-23;B;MIN:1;MAX:999","2023-01-24;B;MIN:1;MAX:999","2023-01-25;B;MIN:1;MAX:999","2023-01-26;B;MIN:1;MAX:999","2023-01-27;B;MIN:1;MAX:999","2023-01-28;B;MIN:1;MAX:999","2023-01-29;B;MIN:1;MAX:999","2023-01-30;B;MIN:1;MAX:999","2023-01-31;B;MIN:1;MAX:999","2023-02-01;B;MIN:1;MAX:999","2023-02-02;B;MIN:1;MAX:999","2023-02-03;B;MIN:1;MAX:999","2023-02-04;B;MIN:1;MAX:999","2023-02-05;B;MIN:1;MAX:999","2023-02-06;B;MIN:1;MAX:999","2023-02-07;B;MIN:1;MAX:999","2023-02-08;B;MIN:1;MAX:999","2023-02-09;B;MIN:1;MAX:999","2023-02-10;B;MIN:1;MAX:999","2023-02-11;B;MIN:1;MAX:999","2023-02-12;B;MIN:1;MAX:999","2023-02-13;B;MIN:1;MAX:999","2023-02-14;B;MIN:1;MAX:999","2023-02-15;B;MIN:1;MAX:999","2023-02-16;B;MIN:1;MAX:999","2023-02-17;B;MIN:1;MAX:999","2023-02-18;B;MIN:1;MAX:999","2023-02-19;B;MIN:1;MAX:999","2023-02-20;B;MIN:1;MAX:999","2023-02-21;B;MIN:1;MAX:999","2023-02-22;B;MIN:1;MAX:999","2023-02-23;B;MIN:1;MAX:999","2023-02-24;B;MIN:1;MAX:999","2023-02-25;B;MIN:1;MAX:999","2023-02-26;B;MIN:1;MAX:999","2023-02-27;B;MIN:1;MAX:999","2023-02-28;B;MIN:1;MAX:999","2023-03-01;B;MIN:1;MAX:999","2023-03-02;B;MIN:1;MAX:999","2023-03-03;B;MIN:1;MAX:999","2023-03-04;B;MIN:1;MAX:999","2023-03-05;B;MIN:1;MAX:999","2023-03-06;B;MIN:1;MAX:999","2023-03-07;B;MIN:1;MAX:999","2023-03-08;B;MIN:1;MAX:999","2023-03-09;B;MIN:1;MAX:999","2023-03-10;B;MIN:1;MAX:999","2023-03-11;B;MIN:1;MAX:999","2023-03-12;B;MIN:1;MAX:999","2023-03-13;B;MIN:1;MAX:999","2023-03-14;B;MIN:1;MAX:999","2023-03-15;B;MIN:1;MAX:999","2023-03-16;B;MIN:1;MAX:999","2023-03-17;B;MIN:1;MAX:999","2023-03-18;B;MIN:1;MAX:999","2023-03-19;B;MIN:1;MAX:999","2023-03-20;B;MIN:1;MAX:999","2023-03-21;B;MIN:1;MAX:999","2023-03-22;B;MIN:1;MAX:999","2023-03-23;B;MIN:1;MAX:999","2023-03-24;B;MIN:1;MAX:999","2023-03-25;B;MIN:1;MAX:999","2023-03-26;B;MIN:1;MAX:999","2023-03-27;B;MIN:1;MAX:999","2023-03-28;B;MIN:1;MAX:999","2023-03-29;B;MIN:1;MAX:999","2023-03-30;B;MIN:1;MAX:999","2023-03-31;B;MIN:1;MAX:999","2023-04-01;B;MIN:1;MAX:999","2023-04-02;B;MIN:1;MAX:999","2023-04-03;B;MIN:1;MAX:999","2023-04-04;B;MIN:1;MAX:999","2023-04-05;B;MIN:1;MAX:999","2023-04-06;B;MIN:1;MAX:999","2023-04-07;B;MIN:1;MAX:999","2023-04-08;B;MIN:1;MAX:999","2023-04-09;B;MIN:1;MAX:999","2023-04-10;B;MIN:1;MAX:999","2023-04-11;B;MIN:1;MAX:999","2023-04-12;B;MIN:1;MAX:999","2023-04-13;B;MIN:1;MAX:999","2023-04-14;B;MIN:1;MAX:999","2023-04-15;B;MIN:1;MAX:999","2023-04-16;B;MIN:1;MAX:999","2023-04-17;B;MIN:1;MAX:999","2023-04-18;B;MIN:1;MAX:999","2023-04-19;B;MIN:1;MAX:999","2023-04-20;B;MIN:1;MAX:999","2023-04-21;B;MIN:1;MAX:999","2023-04-22;B;MIN:1;MAX:999","2023-04-23;B;MIN:1;MAX:999","2023-04-24;B;MIN:1;MAX:999","2023-04-25;B;MIN:1;MAX:999","2023-04-26;B;MIN:1;MAX:999","2023-04-27;B;MIN:1;MAX:999","2023-04-28;B;MIN:1;MAX:999","2023-04-29;B;MIN:1;MAX:999","2023-04-30;B;MIN:1;MAX:999","2023-05-01;B;MIN:1;MAX:999","2023-05-02;B;MIN:1;MAX:999","2023-05-03;B;MIN:1;MAX:999","2023-05-04;B;MIN:1;MAX:999","2023-05-05;B;MIN:1;MAX:999","2023-05-06;B;MIN:1;MAX:999","2023-05-07;B;MIN:1;MAX:999","2023-05-08;B;MIN:1;MAX:999","2023-05-09;B;MIN:1;MAX:999","2023-05-10;B;MIN:1;MAX:999","2023-05-11;B;MIN:1;MAX:999","2023-05-12;B;MIN:1;MAX:999","2023-05-13;B;MIN:1;MAX:999","2023-05-14;B;MIN:1;MAX:999","2023-05-15;B;MIN:1;MAX:999","2023-05-16;B;MIN:1;MAX:999","2023-05-17;B;MIN:1;MAX:999","2023-05-18;B;MIN:1;MAX:999","2023-05-19;B;MIN:1;MAX:999","2023-05-20;B;MIN:2;MAX:999","2023-05-21;B;MIN:1;MAX:999","2023-05-22;B;MIN:1;MAX:999","2023-05-23;B;MIN:1;MAX:999","2023-05-24;B;MIN:1;MAX:999","2023-05-25;B;MIN:1;MAX:999","2023-05-26;B;MIN:1;MAX:999","2023-05-27;B;MIN:1;MAX:999","2023-05-28;B;MIN:1;MAX:999","2023-05-29;B;MIN:1;MAX:999","2023-05-30;B;MIN:1;MAX:999","2023-05-31;B;MIN:1;MAX:999","2023-06-01;B;MIN:1;MAX:999","2023-06-02;B;MIN:1;MAX:999","2023-06-03;B;MIN:2;MAX:999","2023-06-04;B;MIN:1;MAX:999","2023-06-05;B;MIN:1;MAX:999","2023-06-06;B;MIN:1;MAX:999","2023-06-07;B;MIN:1;MAX:999","2023-06-08;B;MIN:1;MAX:999","2023-06-09;B;MIN:1;MAX:999","2023-06-10;B;MIN:1;MAX:999","2023-06-11;B;MIN:1;MAX:999","2023-06-12;B;MIN:1;MAX:999","2023-06-13;B;MIN:1;MAX:999","2023-06-14;B;MIN:1;MAX:999","2023-06-15;B;MIN:1;MAX:999","2023-06-16;B;MIN:1;MAX:999","2023-06-17;B;MIN:1;MAX:999","2023-06-18;B;MIN:1;MAX:999","2023-06-19;B;MIN:1;MAX:999","2023-06-20;B;MIN:1;MAX:999","2023-06-21;B;MIN:1;MAX:999","2023-06-22;B;MIN:1;MAX:999","2023-06-23;B;MIN:1;MAX:999","2023-06-24;B;MIN:1;MAX:999","2023-06-25;B;MIN:1;MAX:999","2023-06-26;B;MIN:1;MAX:999","2023-06-27;B;MIN:1;MAX:999","2023-06-28;B;MIN:1;MAX:999","2023-06-29;B;MIN:1;MAX:999","2023-06-30;B;MIN:1;MAX:999","2023-07-01;B;MIN:1;MAX:999","2023-07-02;B;MIN:1;MAX:999","2023-07-03;B;MIN:1;MAX:999","2023-07-04;B;MIN:1;MAX:999","2023-07-05;B;MIN:1;MAX:999","2023-07-06;B;MIN:1;MAX:999","2023-07-07;B;MIN:1;MAX:999","2023-07-08;B;MIN:1;MAX:999","2023-07-09;B;MIN:1;MAX:999","2023-07-10;B;MIN:1;MAX:999","2023-07-11;B;MIN:1;MAX:999","2023-07-12;B;MIN:1;MAX:999","2023-07-13;B;MIN:1;MAX:999","2023-07-14;B;MIN:1;MAX:999","2023-07-15;B;MIN:1;MAX:999","2023-07-16;B;MIN:1;MAX:999","2023-07-17;B;MIN:1;MAX:999","2023-07-18;B;MIN:1;MAX:999","2023-07-19;B;MIN:1;MAX:999","2023-07-20;B;MIN:1;MAX:999","2023-07-21;B;MIN:1;MAX:999","2023-07-22;B;MIN:1;MAX:999","2023-07-23;B;MIN:1;MAX:999","2023-07-24;B;MIN:1;MAX:999","2023-07-25;B;MIN:1;MAX:999","2023-07-26;B;MIN:1;MAX:999","2023-07-27;B;MIN:1;MAX:999","2023-07-28;B;MIN:1;MAX:999","2023-07-29;B;MIN:1;MAX:999","2023-07-30;B;MIN:1;MAX:999","2023-07-31;B;MIN:1;MAX:999","2023-08-01;B;MIN:1;MAX:999","2023-08-02;B;MIN:1;MAX:999","2023-08-03;B;MIN:1;MAX:999","2023-08-04;B;MIN:1;MAX:999","2023-08-05;B;MIN:1;MAX:999","2023-08-06;B;MIN:1;MAX:999","2023-08-07;B;MIN:1;MAX:999","2023-08-08;B;MIN:1;MAX:999","2023-08-09;B;MIN:1;MAX:999","2023-08-10;B;MIN:1;MAX:999","2023-08-11;B;MIN:1;MAX:999","2023-08-12;B;MIN:1;MAX:999","2023-08-13;B;MIN:1;MAX:999","2023-08-14;B;MIN:1;MAX:999","2023-08-15;B;MIN:1;MAX:999","2023-08-16;B;MIN:1;MAX:999","2023-08-17;B;MIN:1;MAX:999","2023-08-18;B;MIN:1;MAX:999","2023-08-19;B;MIN:1;MAX:999","2023-08-20;B;MIN:1;MAX:999","2023-08-21;B;MIN:1;MAX:999","2023-08-22;B;MIN:1;MAX:999","2023-08-23;B;MIN:1;MAX:999","2023-08-24;B;MIN:1;MAX:999","2023-08-25;B;MIN:1;MAX:999","2023-08-26;B;MIN:1;MAX:999","2023-08-27;MIN:1;MAX:999","2023-08-28;MIN:1;MAX:999","2023-08-29;B;MIN:1;MAX:999","2023-08-30;MIN:1;MAX:999","2023-08-31;MIN:1;MAX:999","2023-09-01;MIN:1","2023-09-02;MIN:1","2023-09-03;MIN:1","2023-09-04;MIN:1","2023-09-05;MIN:1","2023-09-06;MIN:1","2023-09-07;MIN:1","2023-09-08;MIN:1","2023-09-09;MIN:1","2023-09-10;MIN:1","2023-09-11;MIN:1","2023-09-12;MIN:1","2023-09-13;MIN:1","2023-09-14;MIN:1","2023-09-15;MIN:1","2023-09-16;MIN:1","2023-09-17;MIN:1","2023-09-18;MIN:1","2023-09-19;MIN:1","2023-09-20;MIN:1","2023-09-21;MIN:1","2023-09-22;MIN:1","2023-09-23;MIN:2","2023-09-24;MIN:1","2023-09-25;MIN:1","2023-09-26;MIN:1","2023-09-27;MIN:1","2023-09-28;MIN:1","2023-09-29;MIN:1","2023-09-30;MIN:1","2023-10-01;MIN:1","2023-10-02;MIN:1","2023-10-03;MIN:1","2023-10-04;MIN:1","2023-10-05;MIN:1","2023-10-06;MIN:1","2023-10-07;MIN:1","2023-10-08;MIN:1","2023-10-09;MIN:1","2023-10-10;MIN:1","2023-10-11;MIN:2","2023-10-12;MIN:1","2023-10-13;MIN:1","2023-10-14;MIN:1","2023-10-15;MIN:1","2023-10-16;MIN:1","2023-10-17;MIN:1","2023-10-18;MIN:1","2023-10-19;MIN:1","2023-10-20;MIN:1","2023-10-21;MIN:1","2023-10-22;MIN:1","2023-10-23;MIN:1","2023-10-24;MIN:1","2023-10-25;MIN:1","2023-10-26;MIN:1","2023-10-27;MIN:1","2023-10-28;MIN:1","2023-10-29;MIN:1","2023-10-30;MIN:1","2023-10-31;MIN:1","2023-11-01;MIN:1","2023-11-02;MIN:1","2023-11-03;MIN:1","2023-11-04;MIN:1","2023-11-05;MIN:1","2023-11-06;MIN:1","2023-11-07;MIN:1","2023-11-08;MIN:1","2023-11-09;MIN:1","2023-11-10;MIN:1","2023-11-11;MIN:1","2023-11-12;MIN:1","2023-11-13;MIN:1","2023-11-14;MIN:1","2023-11-15;MIN:1","2023-11-16;MIN:1","2023-11-17;MIN:1","2023-11-18;MIN:1","2023-11-19;MIN:1","2023-11-20;MIN:1","2023-11-21;MIN:1","2023-11-22;MIN:1","2023-11-23;MIN:1","2023-11-24;MIN:1","2023-11-25;MIN:1","2023-11-26;MIN:1","2023-11-27;MIN:1","2023-11-28;MIN:1","2023-11-29;MIN:1","2023-11-30;MIN:1","2023-12-01;MIN:1","2023-12-02;MIN:1","2023-12-03;MIN:1","2023-12-04;MIN:1","2023-12-05;MIN:1","2023-12-06;MIN:1","2023-12-07;MIN:1","2023-12-08;MIN:1","2023-12-09;MIN:1","2023-12-10;MIN:1","2023-12-11;MIN:1","2023-12-12;MIN:1","2023-12-13;MIN:1","2023-12-14;MIN:1","2023-12-15;MIN:1","2023-12-16;MIN:1","2023-12-17;MIN:1","2023-12-18;MIN:1","2023-12-19;MIN:1","2023-12-20;MIN:1","2023-12-21;MIN:1","2023-12-22;MIN:1","2023-12-23;MIN:1","2023-12-24;MIN:1","2023-12-25;MIN:1","2023-12-26;MIN:1","2023-12-27;MIN:1","2023-12-28;MIN:1","2023-12-29;MIN:1","2023-12-30;MIN:1","2023-12-31;MIN:2","2024-01-01;MIN:1"];
export type RoomUnavailableDays = {
    checkin: Date[];
    checkout: Date[];
};

export const roomDateModifier = {
    blocked: "B", // blocked
    cantDepart: "DX", // can't depart
    cantArrive: "AX", // can't arrive
};

export type FilterBookingType = "instant" | undefined;
export type SortType = "default" | "price_asc" | "price_desc" | "popular";

export type Filter = {
    roomType?: string[];
    bookingType?: FilterBookingType;
    amenities?: string[];
    numberOfBeds?: number;
    numberOfBedrooms?: number;
    numberOfBathrooms?: number;
    showOnlyTopPartners?: boolean;
    price_from?: number;
    price_to?: number;
};

export type mithobhai = {
    firsttimeload?: boolean;
};

export type SimpleSearchUrlProps = {
    language?: string;
    location?: string;
    startDate?: string;
    endDate?: string;
    guestCount?: string;
};

export type SearchUrlProps = {
    language?: Language;
    location?: SearchLocation;
    startDate?: Date;
    endDate?: Date;
    guestCount?: number;
} & Filter;

export type SearchApiParams = {
    paginationSkip: number;
    paginationLimit: number;
    sort: SortType;
    priceFrom: number;
    roomCategoryId?: string;
    propertyId?: string;
} & SearchUrlProps;

export const defaultFilter: Filter = {
    roomType: [],
    amenities: [],
    showOnlyTopPartners: false,
};

export const defaultMithobhai: mithobhai = {
    firsttimeload: true,
};


export interface SearchResponse {
    count: number;
    address: string;
    pagination: Pagination;
    results: RoomResult[];
}

export interface PropertySearchResponse {
    count: number;
    pagination: Pagination;
    results: PropertyResult[];
}

export interface Pagination {
    skip: number;
    limit: number;
}

export interface RoomResult {
    name: string;
    location: Location;
    address: Address;
    photos: Photo[];
    slug: string;
    fixedSlug: string;
    minAveragePrice: number;
    property: Property;
    roomCategory: RoomCategory;
    logo?: string;
}

export interface PropertyResult {
    property: Property;
    roomCategories: { roomCategory: RoomCategory }[];
}

export interface Address {
    city: string;
    country: string;
}

export interface Location {
    type: LocationType;
    coordinates: number[];
}

export enum LocationType {
    Point = "Point",
}

export interface Photo {
    url: string;
    description: string;
    _id: string;
}

export interface Property {
    _id: string;
    name: string;
    location: Location;
    address: Address;
    photos: Photo[];
    company: Company;
    logo?: string;
}

export interface Company {
    _id: string;
    logo: string;
}

export interface RoomCategory {
    _id: string;
    name: string;
    photos: Photo[];
    pricing: Pricing;
    capacity: number;
    size: number;
    bathrooms: Bathroom[];
    bedrooms: Bedroom[];
    numberOfRooms: number;
    bookingType: BookingType;
    roomType: RoomType;
    hasKitchen: boolean;
    featured: boolean;
    slug: string;
    fixedSlug: string;
    numberOfBathrooms: number;
    numberOfBedrooms: number;
    numberOfBeds: number;
    onlyMonthlyBookable: boolean;
    maxOccupancy: number;
    property: string;
    isAvailable: boolean;
    onHns?: boolean;
}

export enum Bathroom {
    Private = "private",
    Shared = "shared",
}

export interface Bedroom {
    no: string;
    beds: Bed[];
}

export interface Bed {
    type: string;
    count: number;
}

export enum BookingType {
    Instant = "instant",
    Request = "request",
}

export interface Pricing {
    additionalGuestFee: Fee;
    cleaningFee: Fee;
    strategy: Strategy;
    weekday: number;
    weekend: number;
    weeklyPriceMultiplier: number;
    monthlyPriceMultiplier: number;
    currency: string;
    totalStay: number;
    totalOriginal: number;
    totalDuration: number;
    security: number;
    average: number;
    averageMonthly: number;
    hasSpecialBusinessOffers: boolean;
    isSpecialBusinessOffer: boolean;
    totalBarRate: number;
}

export interface Fee {
    price: number;
    type: AdditionalGuestFeeType;
}

export enum AdditionalGuestFeeType {
    Daily = "daily",
    PerStay = "per_stay",
}

export enum Strategy {
    PerRoom = "per_room",
}

export enum RoomType {
    Apart = "apart",
    Hotel = "hotel",
}

export type GuestList = {
    guests: number;
};
